export default __webpack_public_path__ + "static/media/Prior Intimation of Board Meeting.2eac3d22.pdf";